// removed by extract-text-webpack-plugin
module.exports = {"smallButton":"_1MBxY","page":"_2dGRs","orchestraPageFlexContainer":"_28-cr","scenePreferencesPanel":"_3hnES","sceneArrangePanel":"_1je6G","react-resizable":"q_-Li","react-resizable-handle":"_2DTqu","orchestraAdminHelpText":"Zpf9G","smallButtonActive":"_1U-Ed _1MBxY","sceneTypeDescription":"_3irsI"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Orchestras.css
// module id = 860
// module chunks = 0